import styled, { css } from "styled-components";

export const TabButtonStyle = styled.button<{ active?: boolean }>`
  display: flex;
  padding: 0rem 1rem 2rem 1rem;
  justify-content: center;
  align-items: center;

  color: ${({ theme }) => theme.color.text.middleEmphasis};
  font-size: 1.6rem;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  line-height: 2.4rem;
  letter-spacing: -0.048rem;

  border-bottom: 0.1rem solid ${({ theme }) => theme.color.stroke.light};

  ${({ theme, active }) =>
    active &&
    css`
      border-bottom: 0.2rem solid ${theme.color.stroke.secondary};
    `}
`;

export const CountStyle = styled.span`
  color: ${({ theme }) => theme.color.brick[400]};
`;
